import {Pipe, PipeTransform} from '@angular/core';
import {GeneralUtils} from '../../Shared/Utils/general.utils';

@Pipe({
  name: 'sortBy',
  standalone: false
})
export class SortByPipe implements PipeTransform {

  transform(items: any[], keys: string[], direction: 'asc' | 'desc' = 'desc'): any[] {

    if (!items || items.length === 0) {
      return [];
    }

    return GeneralUtils.orderBy(items, keys, direction);

  }

}
